"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return {
    filteredAuxiliaries: filteredAuxiliaries,
    notFilteredAuxiliaries: notFilteredAuxiliaries,
    all: filteredAuxiliaries.concat(notFilteredAuxiliaries)
  };
}; // These auxiliaries are filtered from the beginning of word combinations in the prominent words.


var filteredAuxiliaries = ["am", "is", "are", "was", "were", "been", "get", "gets", "got", "gotten", "be", "she's", "he's", "it's", "i'm", "we're", "they're", "you're", "isn't", "weren't", "wasn't", "that's", "aren't"]; // These auxiliaries are not filtered from the beginning of word combinations in the prominent words.

var notFilteredAuxiliaries = ["being", "getting", "having", "what's"];
/**
 * Returns a list of English auxiliaries.
 *
 * @returns {Object} English auxiliaries.
 */